
import { Component, Vue, Prop } from 'vue-property-decorator';
import QuickActions from './QuickActions.vue';
import { UserInfo } from '@/types/user-info';
import { helpAndSupportURL } from '@/constants/constants';

@Component({
    components: { QuickActions },
})
export default class UserQuickActions extends Vue {
    actions = [
        { handler: this.signin, key: 'signin', title: 'Sign in settings' },
        { handler: this.help, key: 'help', title: 'Help and support' },
    ];

    @Prop({
        default() {
            return [];
        },
    })
    options!: string[];

    @Prop({ required: false })
    onSignin!: (user: UserInfo) => void;

    @Prop({ required: true })
    user!: UserInfo;

    async signin() {
        this.onSignin && (await this.onSignin(this.user));
    }

    help() {
        window.open(helpAndSupportURL, '_blank')?.focus();
        // this.$router.push({ name: 'support' });
    }
}
